// NOTE: For future reference, we can use a .env file if needed
// export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const knownDomains = [
    "app.basalan.test",
    "pre.basalan.ingunet.net",
    "app.basalan.geoinnova.org",
    "basalan.es",
    "auth.basalan.es"
];

function checkDomain(knownDomains) {
    // Get the current domain
    const currentDomain = window.location.hostname;

    // Compare the current domain with the list of known domains
    for (let i = 0; i < knownDomains.length; i++) {
        if (currentDomain === knownDomains[i]) {
            return currentDomain; // Return the matching domain
        }
    }

    return knownDomains[0] || null; // Defaults
}

export const API_BASE_URL = `https://${checkDomain(knownDomains)}/api`;
export const API_LOGIN_CALLBACK = API_BASE_URL + '/sso/login';


